import { WeaTools } from 'ecCom';

export const getHasRight = (params = {}) => WeaTools.callApi('/api/hrm/finance/getHasRight', 'GET', params)

export const getTabInfo = (params) => {
    return WeaTools.callApi('/api/hrm/finance/getTabInfo', 'GET', params);
}

export const getFormField = (params) => {
    return WeaTools.callApi('/api/hrm/finance/getHrmFinanceFields', 'GET', params);
}

export const getSearchList = (params) => {
    return WeaTools.callApi('/api/hrm/finance/getHrmResourceSalaryLog', 'GET', params);
}

export const saveFormFields = (params) => {
    return WeaTools.callApi('/api/hrm/finance/save', 'POST', params);
}

export const isNeedSecondPwdVerify = (params) => {
    return WeaTools.callApi('/api/hrm/finance/isNeedSecondPwdVerify', 'GET', params);
}

export const fetchForm = (params) => {
    return WeaTools.callApi('/api/hrm/finance/getSecondaryPasswordForm', 'GET', params);
}

export const checkSecondPasword = (params) => {
    return WeaTools.callApi('/api/hrm/finance/checkSecondPasword', 'POST', params);
}

export const getPasswordSetting = (params) => {
    return WeaTools.callApi('/api/hrm/password/getPasswordSetting', 'GET', params);
}






// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/finance.js